// src/modules/documentacion/pages/DocumentacionPage.jsx
// Indice de guias/manual interno. Pensado para crecer: cada guia nueva es una
// entrada mas en GUIAS + su propia pagina en modules/documentacion/pages.
import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Paper, Stack, Typography, Chip } from "@mui/material";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import DashboardLayout from "../../../layouts/DashboardLayout";
import PageHeader from "../../../components/layout/PageHeader";

const GUIAS = [
  {
    path: "/documentacion/plataformas-de-rastreo",
    titulo: "Plataformas de rastreo (Wialon / Leasecontrol / TRS Rastreo)",
    descripcion:
      "Cómo funciona el árbol de usuarios, grupos y vehículos; cómo se vincula un cliente a cada plataforma; qué hace cada botón y cada opción del menú.",
    etiqueta: "Panel Global · Historial de Cliente",
  },
];

export default function DocumentacionPage() {
  const navigate = useNavigate();

  return (
    <DashboardLayout>
      <PageHeader title="Documentación" subtitle="Guías internas" />

      <Box sx={{ maxWidth: 760, mx: "auto", p: { xs: 1, md: 1.5 } }}>
        <Stack spacing={1.5}>
          {GUIAS.map((g) => (
            <Paper
              key={g.path}
              variant="outlined"
              onClick={() => navigate(g.path)}
              sx={{
                p: 2,
                display: "flex",
                alignItems: "center",
                gap: 1.5,
                cursor: "pointer",
                "&:hover": { bgcolor: (t) => t.palette.action.hover },
              }}
            >
              <MenuBookIcon color="action" />
              <Box sx={{ flex: 1, minWidth: 0 }}>
                <Typography sx={{ fontWeight: 700 }}>{g.titulo}</Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>
                  {g.descripcion}
                </Typography>
                <Chip size="small" variant="outlined" label={g.etiqueta} sx={{ mt: 1 }} />
              </Box>
              <ChevronRightIcon color="action" />
            </Paper>
          ))}
        </Stack>
      </Box>
    </DashboardLayout>
  );
}
